<mat-card class="create-form-container">
  <div id="close-button" (click)="closeForm()">
     <i data-feather="x" id="close-button" ></i>
  </div>
  <h3 class="form-title">Create a Quantum Emulator</h3>
  <form #form="ngForm" (ngSubmit)="submitForm()">
     <mat-form-field appearance="outline" class="full-width">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="name" name="name" placeholder="Quantum Emulator name" required/>
     </mat-form-field>

<mat-form-field
  appearance="outline"
  class="full-width tutorial-field"
  matTooltip="Keep IBM Qiskit selected to run our tutorials"
  [matTooltipDisabled]="isQiskitTutorialEnvironmentSelected()"
  matTooltipPosition="above"
  matTooltipClass="tutorial-tooltip"
>
  <mat-label>Environment</mat-label>

  <mat-select
    [(ngModel)]="environment"
    name="environment"
    required
    (selectionChange)="updateVersions()"
    (openedChange)="onSelectOpenedChange('env', $event)"
  >
    <mat-option
      *ngFor="let env of environments"
      [value]="env.frameworkId"
    >
      {{ env.frameworkIdLabel }}
    </mat-option>
  </mat-select>

  <div
    class="custom-select-arrow select-arrow-env"
    [class.open]="selectEnvOpened"
  >
    <i data-feather="chevron-down"></i>
  </div>
</mat-form-field>

      <div
      *ngIf="isQiskitTutorialEnvironmentSelected()"
      class="tutorial-selection-hint"
      >
      <mat-icon>info_outline</mat-icon>
      <span>{{ tutorialSelectionHint }}</span>
      </div>


   <p class="env-version-hint">
   {{ envVersionsHint }}
   <a [href]="envVersionsDocLink" 
      target="_blank" 
      rel="noopener noreferrer"
      class="hint-link">{{ envVersionsHintLinkText }}</a>
   </p>


<mat-form-field
  appearance="outline"
  class="full-width tutorial-field"
  matTooltip="Keep 2.2.0-py312-cpu selected to run our tutorials"
  [matTooltipDisabled]="isQiskitTutorialVersionSelected()"
  matTooltipPosition="above"
  matTooltipClass="tutorial-tooltip"
>
  <mat-label>Environment Version</mat-label>

  <mat-select
    required
    [(ngModel)]="version"
    name="version"
    [disabled]="!environment"
    (openedChange)="onSelectOpenedChange('version', $event)"
  >
    <mat-option *ngFor="let ver of versions" [value]="ver">
      {{ ver }}
    </mat-option>
  </mat-select>

  <div
    class="custom-select-arrow select-arrow-vers"
    [class.disabled]="!environment"
    [class.open]="selectVersionOpened"
  >
    <i data-feather="chevron-down"></i>
  </div>
</mat-form-field>

<div
  *ngIf="isQiskitTutorialVersionSelected()"
  class="tutorial-selection-hint"
>
  <mat-icon>info_outline</mat-icon>
  <span>{{ tutorialSelectionHint }}</span>
</div>

     <div class="cpu-spec-wrapper">
        <div class="left-col">
           <div class="cpu-selector">
              <label>CPU</label>
              <button mat-icon-button (click)="decrementCPU()" [disabled]="cpu <= 1">
              <mat-icon>remove</mat-icon>
              </button>
              <span class="cpu-count">{{ cpu }}</span>
              <button mat-icon-button (click)="incrementCPU()" [disabled]="cpu >= maxCpu">
              <mat-icon>add</mat-icon>
              </button>
           </div>
        </div>
        <div class="right-col">
           <div class="spec-display">
              <p id="spec-name"> {{ name }}</p>
              <p>Model: {{ getNotebookSpecs().model}}</p>
              <p>CPU: {{ getNotebookSpecs().cpu }} vCores</p>
              <p>RAM: {{ getNotebookSpecs().ram }} GiB</p>
              <p>Temporary local storage: {{ getNotebookSpecs().storage }} GiB SSD</p>
              <p>Public network: {{ getPublicNetworkDisplay() }}</p>
           </div>
        </div>
     </div>
     <div class="button-container">
<button
    type="submit"
    class="desp-button"
    [disabled]="isSubmitting"
  >
    {{ isSubmitting ? 'Creating…' : 'Create a Quantum Emulator' }}
  </button>
     </div>
  </form>
</mat-card>